import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios'; // فقط برای formsubmit خارجی
import api from '../api/client';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useSetRecoilState } from 'recoil';
import { userInfoState, loggedInState } from '../recoil/atoms';
import { toEnglishDigits, toFarsiDigits } from '../assets/utils';
import { getSiteSettings } from '../api/siteSettings';
import rahdariHeader from '../assets/headers/rahdari.png';
import arjanRing from '../assets/pic/arjan_ring.jpg';
import arjanCup from '../assets/pic/arjan_cup.jpg';
import PersonIcon from '@material-ui/icons/Person';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';




const useStyles = makeStyles((theme) => ({
  appBarCustom: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  headerImage: {
    height: 200,
    width: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  mainContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    margin: 0,
    padding: 0,
  },
  contentWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  loginBox: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
  },
  otpBox: {
    maxWidth: 450,
    width: '100%',
    padding: theme.spacing(4),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(2),
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
  },
  otpInput: {
    textAlign: 'center',
    fontSize: '24px',
    letterSpacing: '8px',
    direction: 'ltr',
  },
  timer: {
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  aboutSection: {
    marginTop: theme.spacing(6),
    borderRadius: theme.spacing(2),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    padding: theme.spacing(4),
  },
  footer: {
    backgroundColor: '#2c3e50',
    color: 'white',
    padding: theme.spacing(4, 0),
    marginTop: 'auto',
    width: '100%',
  },
  contactBtn: {
    position: 'fixed',
    top: 16,
    left: 16,
    zIndex: 1000,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  enamadLogo: {
    position: 'fixed',
    bottom: 16,
    left: 16,
    zIndex: 1000,
    cursor: 'pointer',
  },
  switchButton: {
    marginTop: theme.spacing(2),
    backgroundColor: '#4caf50',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#45a049',
    },
  },
  // Slider styles
  sliderWrapper: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    borderRadius: theme.spacing(2),
    boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
    marginBottom: theme.spacing(3),
    background: '#1a1a2e',
    maxHeight: 420,
  },
  sliderTrack: {
    display: 'flex',
    transition: 'transform 0.6s cubic-bezier(0.77,0,0.175,1)',
    height: 420,
  },
  slide: {
    minWidth: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  slideImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  slideOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%)',
    padding: theme.spacing(3, 4),
    color: '#fff',
    textAlign: 'right',
  },
  sliderArrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    background: 'rgba(255,255,255,0.18)',
    backdropFilter: 'blur(6px)',
    border: '1px solid rgba(255,255,255,0.3)',
    color: '#fff',
    width: 44,
    height: 44,
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 22,
    transition: 'background 0.2s',
    '&:hover': {
      background: 'rgba(255,255,255,0.35)',
    },
  },
  sliderDots: {
    position: 'absolute',
    bottom: 12,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: 8,
    zIndex: 10,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.5)',
    cursor: 'pointer',
    transition: 'background 0.3s, transform 0.3s',
  },
  dotActive: {
    background: '#fff',
    transform: 'scale(1.4)',
  },
  enterBtn: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5, 5),
    fontSize: 17,
    fontWeight: 'bold',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    borderRadius: 30,
    boxShadow: '0 6px 20px rgba(102,126,234,0.45)',
    '&:hover': {
      background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
      boxShadow: '0 8px 28px rgba(102,126,234,0.55)',
    },
  },
  loginReveal: {
    width: '100%',
    maxWidth: 450,
    animation: '$fadeSlideDown 0.4s ease',
  },
  '@keyframes fadeSlideDown': {
    from: { opacity: 0, transform: 'translateY(-18px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },

  // ===== صفحهٔ ورود مدرن: کارت وسط صفحه، پنل برند سمت چپ =====
  hero: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(150deg, #101a4d 0%, #1a237e 42%, #4b3fa7 76%, #764ba2 100%)',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      minHeight: 'auto',
      paddingBottom: 44,
    },
  },
  brandPanel: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '40%',
    padding: '48px 44px',
    // فاصلهٔ امن از لبهٔ راست تا متن زیر کارت وسط صفحه نرود
    paddingRight: 130,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 2,
    [theme.breakpoints.down('lg')]: { width: '42%', paddingRight: 150 },
    [theme.breakpoints.down('md')]: {
      position: 'static',
      width: '100%',
      padding: '34px 20px 70px',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  cupBg: {
    position: 'absolute',
    width: '68%',
    right: '-14%',
    bottom: '-20%',
    opacity: 0.17,
    mixBlendMode: 'screen',
    transform: 'rotate(-8deg)',
    pointerEvents: 'none',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      width: 340,
      right: -110,
      bottom: 'auto',
      top: -90,
    },
  },
  ringLogo: {
    width: 92,
    height: 92,
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid rgba(255,215,120,.65)',
    boxShadow: '0 0 34px rgba(255,200,80,.45), 0 8px 24px rgba(0,0,0,.35)',
    marginBottom: 22,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      width: 72,
      height: 72,
      marginBottom: 14,
    },
  },
  brandTitle: {
    fontSize: 28,
    fontWeight: 800,
    lineHeight: 1.6,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { fontSize: 22 },
  },
  brandText: {
    fontSize: 14,
    opacity: 0.85,
    marginTop: 10,
    lineHeight: 2,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { fontSize: 12.5 },
  },
  brandList: {
    listStyle: 'none',
    marginTop: 26,
    padding: 0,
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: { display: 'none' },
  },
  bullet: {
    fontSize: 13,
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    marginBottom: 13,
    opacity: 0.92,
  },
  check: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    background: 'rgba(255,255,255,.18)',
    border: '1px solid rgba(255,255,255,.3)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    flexShrink: 0,
    marginLeft: 8,
  },
  enamadMini: {
    position: 'absolute',
    bottom: 18,
    right: 44,
    fontSize: 10,
    opacity: 0.65,
    zIndex: 4,
    border: '1px solid rgba(255,255,255,.35)',
    padding: '4px 10px',
    borderRadius: 8,
    [theme.breakpoints.down('md')]: { display: 'none' },
  },
  cardWrap: {
    position: 'relative',
    zIndex: 3,
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 390,
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      transform: 'none',
      width: 'auto',
      margin: '-46px 14px 0',
    },
  },
  loginCard: {
    width: '100%',
    background: '#fff',
    borderRadius: 18,
    boxShadow: '0 18px 50px rgba(8, 12, 40, .35)',
    border: '1px solid rgba(255,255,255,.35)',
    padding: '24px 22px',
    position: 'relative',
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      borderRadius: 16,
      padding: '20px 16px',
    },
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 800,
    textAlign: 'center',
    marginBottom: 4,
  },
  cardSub: {
    fontSize: 12.5,
    color: '#7a80a3',
    textAlign: 'center',
    marginBottom: 14,
  },
  tabs: {
    display: 'flex',
    background: '#eef0f8',
    borderRadius: 12,
    padding: 4,
    marginBottom: 14,
  },
  tab: {
    flex: 1,
    border: 0,
    background: 'transparent',
    textAlign: 'center',
    fontSize: 13,
    fontWeight: 700,
    padding: '10px 6px',
    borderRadius: 9,
    color: '#6b7192',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'all .2s',
  },
  tabActive: {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(102,126,234,.4)',
  },
  textField: {
    marginBottom: theme.spacing(1.5),
    '& input': { fontSize: 14.5 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      background: '#fbfcff',
      '&.Mui-focused': {
        background: '#fff',
        borderColor: '#667eea',
        boxShadow: '0 0 0 4px rgba(102,126,234,.14)',
      },
    },
    '& .MuiInputLabel-outlined': { fontFamily: 'inherit' },
  },
  loginBtn: {
    width: '100%',
    height: 48,
    border: 0,
    borderRadius: 12,
    cursor: 'pointer',
    marginTop: 6,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    fontSize: 14.5,
    fontWeight: 800,
    textAlign: 'center',
    boxShadow: '0 8px 20px rgba(102,126,234,.42)',
    transition: 'all .2s',
    textTransform: 'none',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 26px rgba(102,126,234,.5)',
    },
    '&:disabled': { opacity: 0.65, transform: 'none' },
  },
  btnArrow: {
    fontSize: 16,
    marginRight: 8,
  },
  firstLoginHint: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    background: '#eef1ff',
    border: '1px solid #d5dcfb',
    borderRight: '4px solid #1a237e',
    borderRadius: 10,
    padding: '10px 12px',
    marginBottom: 14,
    width: '100%',
    boxSizing: 'border-box',
  },
  firstLoginHintBody: {
    flex: 1,
    minWidth: 0,
  },
  firstLoginIcon: {
    color: '#1a237e',
    fontSize: 20,
    marginTop: 2,
  },
  cardLinks: {
    display: 'flex',
    justifyContent: 'center',
    gap: 20,
    marginTop: 18,
    fontSize: 12.5,
    color: '#7a80a3',
    fontFamily: 'inherit',
  },
  cardLink: {
    color: '#4b3fa7',
    cursor: 'pointer',
    fontWeight: 700,
    '&:hover': { textDecoration: 'underline' },
  },
  secureNote: {
    textAlign: 'center',
    fontSize: 11,
    color: '#9aa1c2',
    marginTop: 14,
  },
}));

export const ContactModal = ({ open, onClose }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    getSiteSettings().then((d) => d && setCfg(d));
  }, []);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(0);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const isAuthed = (() => {
    try { return !!localStorage.getItem('access') } catch (e) { return false }
  })();

  const getToken = () => {
    try { return localStorage.getItem('access') || '' } catch (e) { return '' }
  };

  useEffect(() => {
    if (timer <= 0) return undefined;
    const t = setInterval(() => setTimer((v) => (v <= 1 ? 0 : v - 1)), 1000);
    return () => clearInterval(t);
  }, [timer]);

  const requestCode = async () => {
    setError('');
    const m = toEnglishDigits(String(mobile || '').trim());
    if (!/^09\d{9}$/.test(m)) {
      setError('شمارهٔ همراه باید ۱۱ رقم و با ۰۹ آغاز شود (مثلاً ۰۹۱۲۱۲۳۴۵۶۷).');
      return;
    }
    setSending(true);
    try {
      const res = await api.post('users/support/otp/', { mobile: m });
      setOtpSent(true);
      setTimer(res.data.expires_in || 300);
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'ارسال کد ممکن نشد');
    } finally {
      setSending(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!subject.trim() || !message.trim()) {
      setError('لطفاً موضوع و متن پیام را وارد کنید');
      return;
    }
    const payload = { subject: subject.trim(), message: message.trim() };
    if (!isAuthed) {
      const m = toEnglishDigits(String(mobile || '').trim());
      if (!/^09\d{9}$/.test(m)) { setError('شمارهٔ همراه معتبر نیست'); return; }
      if (!otpSent) { setError('ابتدا «ارسال کد» را بزنید'); return; }
      if (!code.trim()) { setError('کد تأیید را وارد کنید'); return; }
      payload.mobile = m;
      payload.code = toEnglishDigits(String(code).trim());
    }
    setSending(true);
    try {
      const token = getToken();
      const config = token ? { headers: { Authorization: 'Bearer ' + token } } : undefined;
      await api.post('users/support/contact/', payload, config);
      setSent(true);
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'ارسال پیام ممکن نشد. لطفاً دوباره تلاش کنید.');
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    setSubject('');
    setMessage('');
    setMobile('');
    setCode('');
    setOtpSent(false);
    setTimer(0);
    setSent(false);
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ textAlign: 'right' }}>تماس با ما</DialogTitle>
      <DialogContent>
        {sent ? (
          <Box textAlign="center" py={3}>
            <Typography variant="h6" color="primary">
              پیام شما ثبت شد ✓
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8, lineHeight: 2 }}>
              {isAuthed
                ? 'پاسخ ادمین در بخش «پیام‌ها» برای شما ارسال می‌شود.'
                : 'پاسخ به همین شماره پیامک می‌شود.'}
            </Typography>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            {!isAuthed && (
              <>
                <Typography variant="body2" style={{ color: '#5a6b8c', marginBottom: 8 }}>
                  برای ارسال، شمارهٔ همراه شما باید تأیید شود.
                </Typography>
                <Box display="flex" gap={1} alignItems="flex-start" style={{ marginBottom: 8 }}>
                  <TextField
                    fullWidth
                    label="شمارهٔ موبایل"
                    variant="outlined"
                    value={mobile}
                    onChange={(e) => setMobile(toEnglishDigits(e.target.value))}
                    placeholder="09123456789"
                    inputProps={{ maxLength: 11, style: { direction: 'ltr', textAlign: 'center' } }}
                  />
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={requestCode}
                    disabled={sending || timer > 0}
                    style={{ minWidth: 110, height: 56, fontWeight: 700 }}
                  >
                    {timer > 0 ? `${Math.floor(timer / 60)}:${String(timer % 60).padStart(2, '0')}` : 'ارسال کد'}
                  </Button>
                </Box>
                {otpSent && (
                  <TextField
                    fullWidth
                    label="کد تأیید"
                    variant="outlined"
                    value={code}
                    onChange={(e) => setCode(toEnglishDigits(e.target.value))}
                    inputProps={{ maxLength: 6, style: { direction: 'ltr', textAlign: 'center' } }}
                    style={{ marginBottom: 16 }}
                  />
                )}
              </>
            )}
            <TextField
              fullWidth
              label="موضوع"
              variant="outlined"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              style={{ marginBottom: 16, marginTop: 8 }}
            />
            <TextField
              fullWidth
              label="متن پیام"
              variant="outlined"
              multiline
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={{ marginBottom: 16 }}
            />
            {error && (
              <MuiAlert severity="error" style={{ marginBottom: 12 }}>
                {error}
              </MuiAlert>
            )}
            <Box borderTop="1px solid #eee" pt={2} mt={1} style={{ direction: 'rtl', textAlign: 'right' }}>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 4 }}>
                📍 {cfg?.contact?.address || 'اهواز، کیان‌آباد، بین خ ۶ و ۷ غربی، شرکت ارجان آرایه پویا'}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                📞 {toFarsiDigits(cfg?.contact?.phone || '09166015508')}
              </Typography>
            </Box>
          </form>
        )}
      </DialogContent>
      <DialogActions>
        {!sent && (
          <Button onClick={handleSubmit} color="primary" variant="contained" disabled={sending}>
            {sending ? <CircularProgress size={20} /> : 'ارسال'}
          </Button>
        )}
        <Button onClick={handleClose} color="default">
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const LoginPage = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('نام کاربری یا کلمه عبور نادرست است.');
  const setLoggedIn = useSetRecoilState(loggedInState);
  const setUserInfo = useSetRecoilState(userInfoState);

  const [loginMethod, setLoginMethod] = useState('password');
  const [otpStep, setOtpStep] = useState(1);
  const [username, setUsername] = useState('');
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [otpLoading, setOtpLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [successMessage, setSuccessMessage] = useState('');
  const [contactOpen, setContactOpen] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [siteCfg, setSiteCfg] = useState(null);

  useEffect(() => {
    getSiteSettings().then((d) => d && setSiteCfg(d));
  }, []);

  // مقادیر عمومی از تنظیمات سایت (fallback: همان مقادیر قبلی)
  const enamadId = siteCfg?.enamad?.id || '492744';
  const enamadCode = siteCfg?.enamad?.code || 'NtntQkX9VA2gZRZQh9wfTBZ411kMtTBl';

  const isRahdari = window.location.host === 'rahdari.arjanpeyman.ir';

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            setErrorMessage('کد تأیید منقضی شد. لطفاً دوباره درخواست کنید');
            setOpen(true);
            setOtpStep(1);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const formik = useFormik({
    initialValues: { username: '', password: '' },
    validationSchema: Yup.object({
      username: Yup.string().required('نام کاربری الزامی است'),
      password: Yup.string().required('رمز عبور الزامی است'),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          username: toEnglishDigits(values.username),
          password: toEnglishDigits(values.password),
        };
        const result = await api.post('users/login/', payload);
        if (result.status === 200) {
          const { user, tokens } = result.data;
          // اولین ورود / رمزِ موقت ⇒ تعیینِ رمز پیش از ورود به پنل
          if (result.data.setup_required) {
            try {
              localStorage.setItem('setup_token', result.data.setup_token || '');
              if (tokens && tokens.access) {
                localStorage.setItem('access', tokens.access);
                localStorage.setItem('refresh', tokens.refresh);
              }
            } catch (e) { /* noop */ }
            window.location.assign('/set-password');
            return;
          }
          localStorage.setItem('access', tokens.access);
          localStorage.setItem('refresh', tokens.refresh);
          api.defaults.headers.common['Authorization'] = `Bearer ${tokens.access}`;
          setUserInfo(user);
          setLoggedIn(true);
          setOpen(false);
        } else {
          setErrorMessage('نام کاربری یا کلمه عبور نادرست است.');
          setOpen(true);
        }
      } catch (err) {
        setErrorMessage('نام کاربری یا کلمه عبور نادرست است.');
        setOpen(true);
      }
    },
  });

  const handleRequestOTP = async (e) => {
    e.preventDefault();
    setOpen(false);
    setSuccessMessage('');
    setOtpLoading(true);
    const usernameDigits = toEnglishDigits(username.trim());
    const mobileDigits = toEnglishDigits(mobile);
    if (!usernameDigits) {
      setErrorMessage('لطفاً نام کاربری را وارد کنید');
      setOpen(true);
      setOtpLoading(false);
      return;
    }
    if (!mobileDigits || mobileDigits.length !== 11 || !mobileDigits.startsWith('09')) {
      setErrorMessage('لطفاً شماره موبایل معتبر وارد کنید (مثال: 09123456789)');
      setOpen(true);
      setOtpLoading(false);
      return;
    }
    try {
      const result = await api.post('users/otp/request/', {
        username: usernameDigits,
        mobile: mobileDigits,
      });
      if (result.data.success) {
        setSuccessMessage(result.data.message);
        setTimer(result.data.expires_in);
        setOtpStep(2);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setErrorMessage(err.response.data.error || 'خطا در ارسال کد تأیید');
        if (err.response.data.message) setSuccessMessage(err.response.data.message);
      } else {
        setErrorMessage('خطا در اتصال به سرور');
      }
      setOpen(true);
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setOpen(false);
    setOtpLoading(true);
    const otpDigits = toEnglishDigits(otp);
    if (!otpDigits || otpDigits.length !== 6) {
      setErrorMessage('کد تأیید باید 6 رقمی باشد');
      setOpen(true);
      setOtpLoading(false);
      return;
    }
    try {
      const result = await api.post('users/otp/verify/', {
        username: toEnglishDigits(username.trim()),
        mobile: toEnglishDigits(mobile),
        otp: otpDigits,
      });
      if (result.data.setup_required) {
        try {
          localStorage.setItem('setup_token', result.data.setup_token || '');
          if (result.data.tokens && result.data.tokens.access) {
            localStorage.setItem('access', result.data.tokens.access);
            localStorage.setItem('refresh', result.data.tokens.refresh);
          }
        } catch (e) { /* noop */ }
        window.location.assign('/set-password');
        return;
      }
      if (result.data.tokens) {
        const { user, tokens } = result.data;
        localStorage.setItem('access', tokens.access);
        localStorage.setItem('refresh', tokens.refresh);
        api.defaults.headers.common['Authorization'] = `Bearer ${tokens.access}`;
        setUserInfo(user);
        setLoggedIn(true);
        setOpen(false);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setErrorMessage(err.response.data.error || 'کد تأیید اشتباه است');
        if (err.response.data.remaining_attempts !== undefined) {
          setSuccessMessage(`${err.response.data.remaining_attempts} تلاش باقی مانده`);
        }
      } else {
        setErrorMessage('خطا در اتصال به سرور');
      }
      setOpen(true);
      setOtp('');
    } finally {
      setOtpLoading(false);
    }
  };

  const scrollToAbout = () => {
    document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  // محتوای اصلی ورود — بین حالت عادی و راهداری مشترک (تب + فرم رمز یا OTP)
  const renderAuthContent = () => (
    <>
      <div className={classes.tabs}>
        <button
          type="button"
          className={`${classes.tab} ${loginMethod === 'password' ? classes.tabActive : ''}`}
          onClick={() => setLoginMethod('password')}
        >
          ورود با رمز
        </button>
        <button
          type="button"
          className={`${classes.tab} ${loginMethod === 'otp' ? classes.tabActive : ''}`}
          onClick={() => setLoginMethod('otp')}
        >
          رمز یکبار مصرف
        </button>
      </div>

      {loginMethod === 'password' ? (
        <>
        {/* راهنمای اولین ورود — نامِ کاربری و رمز هر دو کدِ ملی هستند */}
        {/* نکته: direction/textAlign باید inline باشد؛ پلاگین jss-rtl مقادیرِ
            کلاس را معکوس می‌کند (rtl ⇒ ltr) و متن را چپ می‌چیند. */}
        <Box className={classes.firstLoginHint} style={{ direction: 'rtl', textAlign: 'right' }}>
          <InfoOutlinedIcon className={classes.firstLoginIcon} />
          <Box className={classes.firstLoginHintBody} style={{ direction: 'rtl', textAlign: 'right' }}>
            <Typography variant="body2" style={{ fontWeight: 700, color: '#1a237e', textAlign: 'right' }}>
              اولین ورود:
            </Typography>
            <Typography variant="body2" style={{ color: '#4a5578', lineHeight: 1.9, textAlign: 'right' }}>
              رمزِ عبور فقط در <b>اولین ورود</b> توسط خودتان تعیین می‌شود. اگر هنوز رمز
              ندارید، «ادعای حساب» را بزنید: کد ملی، شمارهٔ یکی از قراردادهای خودتان و
              سالِ آن قرارداد را وارد می‌کنید و کد تأیید به شمارهٔ موبایلی که وارد
              می‌کنید فرستاده می‌شود.
            </Typography>
            <Button
              size="small"
              variant="outlined"
              style={{ marginTop: 10 }}
              onClick={() => window.location.assign('/first-login')}
            >
              ادعای حساب / اولین ورود
            </Button>
          </Box>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            variant="outlined"
            label="نام کاربری"
            name="username"
            className={classes.textField}
            value={formik.values.username}
            onChange={formik.handleChange}
            error={formik.touched.username && Boolean(formik.errors.username)}
            helperText={formik.touched.username && formik.errors.username}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon style={{ color: '#9aa1c2' }} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            label="کلمه عبور"
            name="password"
            type={showPass ? 'text' : 'password'}
            className={classes.textField}
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon style={{ color: '#9aa1c2' }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    size="small"
                    aria-label="نمایش کلمه عبور"
                    onClick={() => setShowPass((v) => !v)}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {showPass ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button type="submit" fullWidth className={classes.loginBtn} disabled={formik.isSubmitting}>
            {formik.isSubmitting ? 'در حال ورود...' : 'ورود به سامانه'}
            {!formik.isSubmitting && <span className={classes.btnArrow}>←</span>}
          </Button>
        </form>
        </>
      ) : (
        <div>
          {otpStep === 1 ? (
            <form onSubmit={handleRequestOTP}>
              <TextField
                fullWidth
                label="نام کاربری"
                variant="outlined"
                className={classes.textField}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={otpLoading}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon style={{ color: '#9aa1c2' }} />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                label="شماره موبایل"
                variant="outlined"
                className={classes.textField}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="09123456789"
                inputProps={{ maxLength: 11, style: { direction: 'ltr', textAlign: 'center' } }}
                disabled={otpLoading}
              />
              {successMessage && (
                <MuiAlert severity="success" style={{ marginBottom: 16 }}>
                  {successMessage}
                </MuiAlert>
              )}
              <Button type="submit" fullWidth className={classes.loginBtn} disabled={otpLoading}>
                {otpLoading ? <CircularProgress size={22} style={{ color: '#fff' }} /> : 'دریافت کد تأیید'}
              </Button>

              {/* راهِ جایگزین: حسابی که شمارهٔ همراه ندارد ⇒ ادعای حساب */}
              <Box style={{ marginTop: 14, padding: '10px 12px', background: '#f4f6ff',
                            border: '1px solid #d6ddf5', borderRadius: 10,
                            direction: 'rtl', textAlign: 'right' }}>
                <Typography variant="body2" style={{ color: '#4a5578', lineHeight: 1.9, textAlign: 'right' }}>
                  شمارهٔ همراه شما در سامانه ثبت نشده و کد نمی‌آید؟
                  از <b>«ادعای حساب»</b> استفاده کنید: کد ملی، شمارهٔ یکی از قراردادهای
                  خودتان و سالِ آن را وارد می‌کنید و کد تأیید به شماره‌ای که وارد می‌کنید می‌رود.
                </Typography>
                <Button
                  size="small"
                  variant="outlined"
                  style={{ marginTop: 8, fontWeight: 700 }}
                  onClick={() => window.location.assign('/first-login')}
                >
                  ادعای حساب / ثبت شمارهٔ همراه
                </Button>
              </Box>
            </form>
          ) : (
            <form onSubmit={handleVerifyOTP}>
              <Typography variant="body2" style={{ textAlign: 'center', color: '#666', marginBottom: 10 }}>
                کد ۶ رقمی ارسال‌شده به {mobile} را وارد کنید
              </Typography>
              {timer > 0 && <div className={classes.timer}>⏱️ {formatTimer(timer)}</div>}
              <TextField
                fullWidth
                variant="outlined"
                className={classes.textField}
                value={otp}
                onChange={(e) => setOtp(toEnglishDigits(e.target.value.replace(/\D/g, '')))}
                placeholder="کد 6 رقمی"
                inputProps={{ maxLength: 6, className: classes.otpInput }}
                disabled={otpLoading}
                autoFocus
              />
              {successMessage && (
                <MuiAlert severity="info" style={{ marginBottom: 16 }}>
                  {successMessage}
                </MuiAlert>
              )}
              <Button type="submit" fullWidth className={classes.loginBtn} disabled={otpLoading || otp.length !== 6}>
                {otpLoading ? <CircularProgress size={22} style={{ color: '#fff' }} /> : 'ورود'}
              </Button>
              <Button
                fullWidth
                variant="outlined"
                style={{ marginTop: 8 }}
                onClick={() => {
                  setOtpStep(1);
                  setOtp('');
                  setUsername('');
                  setMobile('');
                  setTimer(0);
                }}
              >
                ارسال مجدد کد
              </Button>
            </form>
          )}
        </div>
      )}
    </>
  );

  return (
    <Box className={classes.mainContainer}>
      {/* Header — فقط برای دامنهٔ راهداری؛ حالت عادی split-screen بدون نوار بالاست */}
      {isRahdari && (
        <Box style={{ width: '100%', height: 200, overflow: 'hidden', margin: 0, padding: 0 }}>
          <img src={rahdariHeader} alt="Header" className={classes.headerImage} />
        </Box>
      )}

      {/* Contact Button (Fixed) — فقط راهداری */}
      {isRahdari && (
        <Button
          className={classes.contactBtn}
          variant="contained"
          size="small"
          onClick={() => setContactOpen(true)}
          startIcon={<span>📞</span>}
        >
          تماس با ما
        </Button>
      )}

      {isRahdari ? (
        <Container maxWidth={false} className={classes.contentWrapper} style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Box
            id="login-form-anchor"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            style={{ minHeight: '30vh' }}
          >
            <div className={classes.loginCard}>
              <Typography variant="h5" className={classes.cardTitle}>
                ورود به سامانه ارجان پیمان
              </Typography>
              {renderAuthContent()}
              <div className={classes.cardLinks}>
                <span className={classes.cardLink} onClick={scrollToAbout}>درباره ما</span>
                <span className={classes.cardLink} onClick={() => setContactOpen(true)}>تماس با ما</span>
              </div>
            </div>
          </Box>
        </Container>
      ) : (
        <>
          {/* صفحهٔ ورود: کارت وسط کل صفحه + پنل برند سمت چپ */}
          <div className={classes.hero}>
            <img className={classes.cupBg} src={arjanCup} alt="" />
            <div className={classes.brandPanel}>
              <img className={classes.ringLogo} src={arjanRing} alt="حلقه طلایی ارجان" />
              <Typography className={classes.brandTitle} component="h1">
                سامانه ارجان پیمان
              </Typography>
              <Typography className={classes.brandText}>
                دسترسی سریع و امن پیمانکاران به آخرین وضعیت قراردادها، صورت وضعیتها و حواله‌ها
              </Typography>
              <ul className={classes.brandList}>
                <li className={classes.bullet}><span className={classes.check}>✓</span> مشاهدهٔ لحظه‌ای قراردادها و صورت وضعیتها</li>
                <li className={classes.bullet}><span className={classes.check}>✓</span> دریافت گزارش PDF و اکسل</li>
                <li className={classes.bullet}><span className={classes.check}>✓</span> ورود امن با رمز یکبار مصرف</li>
              </ul>
            </div>
            <div className={classes.cardWrap}>
              <div className={classes.loginCard}>
                <Typography className={classes.cardTitle} component="h2">خوش آمدید 👋</Typography>
                <Typography className={classes.cardSub}>برای ورود به سامانه اطلاعات خود را وارد کنید</Typography>
                {renderAuthContent()}
                <div className={classes.cardLinks}>
                  <span className={classes.cardLink} onClick={() => window.location.assign('/first-login')} style={{ fontWeight: 800, color: '#0f6e7d' }}>ادعای حساب / اولین ورود</span>
                  <span className={classes.cardLink} onClick={scrollToAbout}>درباره ما</span>
                  <span className={classes.cardLink} onClick={() => setContactOpen(true)}>تماس با ما</span>
                </div>
                <div className={classes.secureNote}>🔒 اتصال امن (HTTPS)</div>
              </div>
            </div>
            <span className={classes.enamadMini}>✓ نماد اعتماد الکترونیکی</span>
          </div>
        </>
      )}

      {/* Main Content */}
      <Container maxWidth={false} className={classes.contentWrapper} style={{ paddingLeft: 16, paddingRight: 16 }}>
        {/* About Section */}
        <Card id="about-section" className={classes.aboutSection}>
          <Typography variant="h5" gutterBottom style={{ fontWeight: 'bold', marginBottom: 16, textAlign: 'center' }}>
            درباره ما
          </Typography>
          <Typography variant="body1" paragraph style={{ textAlign: 'justify', lineHeight: 2 }}>
            سامانه ارجان پیمان به منظور دسترسی آسان اطلاعات قراردادهای پیمانکاران با دستگاههای اجرایی استان خوزستان ایجاد گردیده و هدف آن دسترسی سریع و آسان پیمانکاران به آخرین وضعیت قراردادها و کاهش تردد و مراجعات حضوری است.
          </Typography>
          <Typography variant="body1" paragraph style={{ textAlign: 'justify', lineHeight: 2 }}>
            شرکت ارجان آرایه پویا، مجری نرم افزار جامع مالی تعدادی از دستگاههای اجرایی استان بوده و در صورت موافقت هر دستگاه، امکان اطلاع رسانی آخرین وضعیت قراردادهای منعقده در ارجان پیمان فراهم خواهد شد.
          </Typography>
          <Typography variant="body1" paragraph style={{ textAlign: 'justify', lineHeight: 2 }}>
            از آنجا که ذینفع نهایی ارجان پیمان، پیمانکاران محترم دستگاههای اجرایی هستند، انتظار می رود با ارائه پیشنهادات سازنده، در تکمیل این سامانه تلاش نموده و بدین ترتیب علاوه بر کاهش هزینه های مستقیم و غیر مستقیم خود جهت دسترسی به اطلاعات مورد نیاز، به سودمندی بیشتر آن کمک نمایند.
          </Typography>
          <Typography variant="body1" style={{ textAlign: 'justify', lineHeight: 2 }}>
            ورود به ارجان پیمان با شناسه ملی پیمانکار، هم بعنوان نام کاربری و هم کلمه عبور امکانپذیر است و به منظور حفاظت از اطلاعات، پس از اولین ورود به سامانه و قبل از هر کاری، ثبت شماره تلفن همراه و تغییر کلمه عبور الزامی خواهد بود. پیمانکاران همواره امکان دسترسی به اطلاعات کلی قراردادهای خود را خواهند داشت و دسترسی به اطلاعات بیشتر شامل ضمانتنامه ها، سپرده ها، صورت وضعیت ها و گردش اسناد مربوط به آنها، اسناد خزانه، حواله ها، اسناد حسابداری و محدودیت های (Black List) پیمانکاران و قراردادها با پرداخت حق عضویت سالانه امکانپذیر است. لازم به ذکر است که پیمانکاران محترم با پرداخت حق عضویت سالانه، به کلیه قراردادهای خود در همه دستگاههای اجرایی که اطلاعات شان در ارجان پیمان بارگذاری شده باشد دسترسی خواهند داشت.
          </Typography>
        </Card>
      </Container>

      {/* Footer */}
      <Box component="footer" className={classes.footer}>
        <Container maxWidth={false} disableGutters style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" gutterBottom>
                سامانه ارجان پیمان
              </Typography>
              <Typography variant="body2">راهکار هوشمند برای مدیریت قراردادها</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" gutterBottom>
                تماس با ما
              </Typography>
              <Typography variant="body2" style={{ marginBottom: 8 }}>
                📞 تلفن: {toFarsiDigits(siteCfg?.contact?.phone || '09166015508')}
              </Typography>
              <Typography variant="body2">✉️ ایمیل: {siteCfg?.contact?.email || 'info@arjanpeyman.ir'}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant="h6" gutterBottom>
                آدرس
              </Typography>
              <Typography variant="body2">📍 {siteCfg?.contact?.address || 'اهواز، کیان‌آباد، بین خ ۶ و ۷ غربی، شرکت ارجان آرایه پویا'}</Typography>
            </Grid>
          </Grid>
          <Box style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
            <Typography variant="body2">© {new Date().getFullYear()} تمامی حقوق برای شرکت ارجان آرایه پویا محفوظ است</Typography>
          </Box>
        </Container>
      </Box>

      {/* Enamad Logo */}
      <Box className={classes.enamadLogo}>
        <a
          referrerPolicy="origin"
          target="_blank"
          rel="noreferrer"
          href={`https://trustseal.enamad.ir/?id=${enamadId}&Code=${enamadCode}`}
        >
          <img
            referrerPolicy="origin"
            src={`https://trustseal.enamad.ir/logo.aspx?id=${enamadId}&Code=${enamadCode}`}
            alt="enamad"
            style={{ cursor: 'pointer' }}
            id={enamadCode}
          />
        </a>
      </Box>

      {/* Contact Modal */}
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />

      {/* Error Snackbar */}
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <MuiAlert elevation={6} onClose={() => setOpen(false)} variant="filled" severity="error">
          <Typography>{errorMessage}</Typography>
        </MuiAlert>
      </Snackbar>
    </Box>
  );
};

export default LoginPage;
